import { StringPublicKey } from "@metaplex-foundation/mpl-core";
import {
  MetaDataJsonCategory,
  MetadataJsonCreator,
  MetadataJsonFile,
} from "sdk/nft";

export enum ArtType {
  Master = "Master",
  Print = "Print",
  NFT = "NFT",
}

export enum AuctionState {
  Created = 0,
  Started = 1,
  Ended = 2,
  SoldOut = 3,
}

export interface IArtCreator extends MetadataJsonCreator {
  verified: boolean;
}

export interface IArtCollection {
  verified: boolean;
  address: StringPublicKey;
}

export interface IArt {
  id: StringPublicKey;
  collection?: IArtCollection;
  accountAddress: StringPublicKey;
  token: StringPublicKey;
  tokenAmount: number;
  mint: StringPublicKey;
  primarySaleHappened?: boolean;
  sellerFeeBasisPoints: number;
  image: string;
  title: string;
  description?: string;
  creators: IArtCreator[];
  format: MetaDataJsonCategory;
  assets?: MetadataJsonFile[];
  type: ArtType;
  prints?: IPrintNumbers;
  ownerAddress?: StringPublicKey;
  properties?: IProperty[];
  details?: IDetail[];
  animationUrl?: string;
}

export interface IProperty {
  title: string;
  value: string;
}

export interface IDetail {
  id: string;
  value: string;
}

export interface IPrintNumbers {
  // current print number (ArtType is Print)
  edition?: number;
  // current amount of prints
  supply?: number;
  // maximum amount of prints (0 = unlimited)
  maxSupply?: number;
}
